import React, { FC, useCallback } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { SmallHeadline } from 'components/Typography'
import { GreenTag, RedTag } from 'components/Tag'
import { BlueButton, TextButton } from 'components/Button'
import { FirebaseDocRefType } from 'firebase/index'
import { openModal } from 'reducks/modal/operations'
import { IndividualScheduleModal, IndividualDeliveryScheduleModal } from 'components/Modal'
import { BreadType } from 'types/bread'
import { initBreads } from 'reducks/bread/operations'
import { StockUnionType } from 'types/stock'

type Props = {
  bread: BreadType
  breadName: string
  breadRef: FirebaseDocRefType
  imageUrl: string
  hasStocks: boolean
  type: StockUnionType
}

const ScheduleCard: FC<Props> = (props) => {
  const { bread, breadName, breadRef, imageUrl, hasStocks, type } = props
  const dispatch = useDispatch()

  const goToScheduleConfigPage = useCallback(() => {
    const path = (() => {
      switch (type) {
        case 'preorder':
          return `/schedule/${breadRef.id}`
        case 'delivery':
          return `/schedule/delivery/${breadRef.id}`
        default:
          return `/schedule/${breadRef.id}`
      }
    })()
    dispatch(initBreads())
    dispatch(push(path))
  }, [dispatch, breadRef.id, type])

  const openIndividualSettingModal = useCallback(() => {
    const modal = (() => {
      switch (type) {
        case 'preorder':
          return <IndividualScheduleModal bread={bread} />
        case 'delivery':
          return <IndividualDeliveryScheduleModal bread={bread} />
        default:
          return <IndividualScheduleModal bread={bread} />
      }
    })()
    dispatch(openModal(modal, `個別日の設定を行う`, '設定を変更したい日を選択してください。'))
  }, [dispatch, type])

  return (
    <div className={styles.row__inner}>
      <FlexRow justifyContent={'start'} alignItems={'start'}>
        <div className={styles.row__image}>
          <img src={imageUrl} alt={breadName} />
        </div>
        <Spacer size={12} />
        <div className={styles.row__body}>
          <FlexRow justifyContent={'between'} alignItems={'start'}>
            <div>
              <SmallHeadline label={breadName} />
              <Spacer size={8} />
              <FlexRow justifyContent={'start'}>
                <span className={`${text.font_small} ${text.color_grey_01}`}>現在の設定 ： </span>
                <Spacer size={2} />
                {hasStocks ? (
                  <GreenTag shape={'ellipse'} startIcon={'/icon/white/circle.svg'} tagName={'受付中'} />
                ) : (
                  <RedTag shape={'ellipse'} startIcon={'/icon/white/close.svg'} tagName={'未設定'} />
                )}
              </FlexRow>
            </div>
            <Spacer size={12} />
            <BlueButton label={'変更'} onClick={goToScheduleConfigPage} size={'xxsmall'} type={'outlined'} />
          </FlexRow>
          <Spacer size={12} />
          <TextButton label={'個別日の設定を行う'} onClick={openIndividualSettingModal} />
        </div>
      </FlexRow>
    </div>
  )
}

export default ScheduleCard
